<template>
  <div class="card-on-card card-outline-secondary">
    <div class="card-header">
      <h5 class="mb-2 font-weight-bold">Informasi Harga</h5>
    </div>
    <template v-if="typeBook == 'text'">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="form-row">
              <div class="col-md-4">
                <div class="form-group">
                  <label>PPN 10%</label>
                  <select name="bookPpn" class="form-control" id="bookPpn">
                    <option value="0">Non PPN</option>
                    <option value="1">Include PPN</option>
                    <option value="2">Exclude PPN</option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Harga Zona I</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <label class="input-group-text">Rp.</label>
                    </div>
                    <CurrencyInput
                      v-if="renderComponent"
                      name="bookPriceZone1"
                      @keyup="autoCorrectPrice('bookPriceZone1', 'maxZone1')"
                      :value="zone1"
                      class="form-control"
                      id="bookPriceZone1"
                    />
                    <div class="invalid-feedback invalidbookPriceZone1"></div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="">Harga Maksimal</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <label for="" class="input-group-text">Rp.</label>
                    </div>
                    <CurrencyInput
                      v-if="renderComponent"
                      :value="zone1"
                      readonly="true"
                      class="form-control"
                      id="maxZone1"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-md-4">
                <div class="form-group">
                  <label>Stok</label>
                  <CurrencyInput
                    v-if="renderComponent"
                    v-model="stock"
                    name="bookStock"
                    class="form-control"
                    id="bookStock"
                    @keyup="validateNotNull('bookStock')"
                  />
                  <div class="invalid-feedback invalidStock"></div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Harga Zona II</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <label class="input-group-text">Rp.</label>
                    </div>
                    <CurrencyInput
                      v-if="renderComponent"
                      name="bookPriceZone2"
                      @keyup="autoCorrectPrice('bookPriceZone2', 'maxZone2')"
                      :value="zone2"
                      class="form-control"
                      id="bookPriceZone2"
                    />
                    <div class="invalid-feedback invalidbookPriceZone2"></div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="">Harga Maksimal</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <label for="" class="input-group-text">Rp.</label>
                    </div>
                    <CurrencyInput
                      v-if="renderComponent"
                      :value="zone2"
                      readonly="true"
                      class="form-control"
                      id="maxZone2"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-md-4"></div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Harga Zona III</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <label class="input-group-text">Rp.</label>
                    </div>
                    <CurrencyInput
                      v-if="renderComponent"
                      name="bookPriceZone3"
                      @keyup="autoCorrectPrice('bookPriceZone3', 'maxZone3')"
                      :value="zone3"
                      class="form-control"
                      id="bookPriceZone3"
                    />
                    <div class="invalid-feedback invalidbookPriceZone3"></div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="">Harga Maksimal</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <label for="" class="input-group-text">Rp.</label>
                    </div>
                    <CurrencyInput
                      v-if="renderComponent"
                      :value="zone3"
                      readonly="true"
                      class="form-control"
                      id="maxZone3"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-md-4"></div>

              <div class="col-md-4">
                <div class="form-group">
                  <label>Harga Zona IV</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <label class="input-group-text">Rp.</label>
                    </div>
                    <CurrencyInput
                      v-if="renderComponent"
                      name="bookPriceZone4"
                      @keyup="autoCorrectPrice('bookPriceZone4', 'maxZone4')"
                      :value="zone4"
                      class="form-control"
                      id="bookPriceZone4"
                    />
                    <div class="invalid-feedback invalidbookPriceZone4"></div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="">Harga Maksimal</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <label for="" class="input-group-text">Rp.</label>
                    </div>
                    <CurrencyInput
                      v-if="renderComponent"
                      :value="zone4"
                      readonly="true"
                      class="form-control"
                      id="maxZone4"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-4"></div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Harga Zona V</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <label class="input-group-text">Rp.</label>
                    </div>
                    <CurrencyInput
                      v-if="renderComponent"
                      name="bookPriceZone5"
                      @keyup="autoCorrectPrice('bookPriceZone5', 'maxZone5')"
                      :value="zone5"
                      class="form-control"
                      id="bookPriceZone5"
                    />
                    <div class="invalid-feedback invalidbookPriceZone5"></div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="">Harga Maksimal</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <label for="" class="input-group-text">Rp.</label>
                    </div>
                    <CurrencyInput
                      v-if="renderComponent"
                      :value="zone5"
                      readonly="true"
                      class="form-control"
                      id="maxZone5"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card-header">
            <b>Harga Grosir</b>
            <button
              class="ml-2 mr-2 btn btn-secondary btn-circle btn-sm collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#grosirCollapse"
              aria-expanded="false"
              aria-controls="grosirCollapse"
            >
              <i
                class="fa fa-compress"
                style="font-size: 12px"
                aria-hidden="true"
              ></i>
            </button>
            <p class="grosir-info">
              Masukkan harga grosir. Harga grosir biasanya lebih murah daripada
              harga satuan. Harga grosir memiliki minimum pembelian dan harga
              bertingkat (3-4 tingkat). Barang seperti ini disebut juga barang
              Wholesale.
            </p>
          </div>
          <div class="card-body collapse" id="grosirCollapse" style="">
            <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="pills-home-tab"
                  data-toggle="pill"
                  href="#grosirZone1"
                  role="tab"
                  aria-controls="pills-home"
                  aria-selected="true"
                  ><span style="font-size: 12px">Grosir Zona 1</span>
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="pills-profile-tab"
                  data-toggle="pill"
                  href="#grosirZone2"
                  role="tab"
                  aria-controls="pills-profile"
                  aria-selected="false"
                  ><span style="font-size: 12px">Grosir Zona 2</span></a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="pills-profile-tab"
                  data-toggle="pill"
                  href="#grosirZone3"
                  role="tab"
                  aria-controls="pills-profile"
                  aria-selected="false"
                  ><span style="font-size: 12px">Grosir Zona 3</span></a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="pills-profile-tab"
                  data-toggle="pill"
                  href="#grosirZone4"
                  role="tab"
                  aria-controls="pills-profile"
                  aria-selected="false"
                  ><span style="font-size: 12px">Grosir Zona 4</span></a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="pills-profile-tab"
                  data-toggle="pill"
                  href="#grosirZone5"
                  role="tab"
                  aria-controls="pills-profile"
                  aria-selected="false"
                  ><span style="font-size: 12px">Grosir Zona 5</span></a
                >
              </li>
            </ul>
            <div class="tab-content" id="pills-tabContent">
              <div
                class="tab-pane fade show active"
                id="grosirZone1"
                role="tabpanel"
                aria-labelledby="grosirZone5-tab"
              >
                <div class="row">
                  <div class="col-12">
                    <div
                      class="form-row"
                      v-for="(fakeForEach, index) in 4"
                      :key="index"
                    >
                      <div class="col-md-2">
                        <div class="form-group">
                          <div class="form-group">
                            <label>Pembelian Minimum</label>
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <label class="input-group-text">Min.</label>
                              </div>
                              <input
                                min="0"
                                max="999999999999"
                                maxlength="20"
                                oninput="this.value=this.value.slice(0,this.maxLength||1/1);
                                this.value=(this.value   < 0) ? (1/1) : this.value;"
                                @keyup="
                                  validateNotNull(
                                    'bookMinWholesaleZone1Part' + (index + 1)
                                  )
                                "
                                class="form-control"
                                type="number"
                                :value="minGrosir[index]"
                                :name="
                                  'bookMinWholesaleZone1Part' + (index + 1)
                                "
                                :id="'bookMinWholesaleZone1Part' + (index + 1)"
                              />
                              <span class="invalid-feedback"
                                >Tidak boleh kosong</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md">
                        <div class="form-group">
                          <label class="text-success"
                            >Harga Grosir {{ index + 1 }}</label
                          >
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <label class="input-group-text">Rp.</label>
                            </div>
                            <CurrencyInput
                              v-if="renderComponent"
                              :value="hargaGrosir[index]"
                              class="form-control"
                              min="0"
                              max="999999999999"
                              maxlength="20"
                              oninput="this.value=this.value.slice(0,this.maxLength||1/1);
                              this.value=(this.value   < 0) ? (1/1) : this.value;"
                              @input="
                                grosirAutoCorrectPrice(
                                  `bookWholesalePriceZone1Part${index + 1}`,
                                  'maxZone1'
                                )
                              "
                              :name="
                                'bookWholesalePriceZone1Part' + (index + 1)
                              "
                              :id="'bookWholesalePriceZone1Part' + (index + 1)"
                            />
                            <div
                              :class="
                                `invalid-feedback invalidbookWholesalePriceZone1Part${index +
                                  1}`
                              "
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade show"
                id="grosirZone2"
                role="tabpanel"
                aria-labelledby="grosirZone5-tab"
              >
                <div class="row">
                  <div class="col-12">
                    <div
                      class="form-row"
                      v-for="(fakeForEach, index) in 4"
                      :key="index"
                    >
                      <div class="col-md-2">
                        <div class="form-group">
                          <div class="form-group">
                            <label>Pembelian Minimum</label>
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <label class="input-group-text">Min.</label>
                              </div>
                              <input
                                min="0"
                                max="999999999999"
                                maxlength="20"
                                oninput="this.value=this.value.slice(0,this.maxLength||1/1);
                                this.value=(this.value   < 0) ? (1/1) : this.value;"
                                @keyup="
                                  validateNotNull(
                                    'bookMinWholesaleZone2Part' + (index + 1)
                                  )
                                "
                                class="form-control"
                                type="number"
                                :value="minGrosir[index]"
                                :name="
                                  'bookMinWholesaleZone2Part' + (index + 1)
                                "
                                :id="'bookMinWholesaleZone2Part' + (index + 1)"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md">
                        <div class="form-group">
                          <label class="text-success"
                            >Harga Grosir {{ index + 1 }}</label
                          >
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <label class="input-group-text">Rp.</label>
                            </div>
                            <CurrencyInput
                              v-if="renderComponent"
                              :value="hargaGrosir[index]"
                              class="form-control"
                              @input="
                                grosirAutoCorrectPrice(
                                  `bookWholesalePriceZone2Part${index + 1}`,
                                  'maxZone2'
                                )
                              "
                              :name="
                                'bookWholesalePriceZone2Part' + (index + 1)
                              "
                              :id="'bookWholesalePriceZone2Part' + (index + 1)"
                            />
                            <div
                              :class="
                                `invalid-feedback invalidbookWholesalePriceZone2Part${index +
                                  1}`
                              "
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade show"
                id="grosirZone3"
                role="tabpanel"
                aria-labelledby="grosirZone5-tab"
              >
                <div class="row">
                  <div class="col-12">
                    <div
                      class="form-row"
                      v-for="(fakeForEach, index) in 4"
                      :key="index"
                    >
                      <div class="col-md-2">
                        <div class="form-group">
                          <div class="form-group">
                            <label>Pembelian Minimum</label>
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <label class="input-group-text">Min.</label>
                              </div>
                              <input
                                min="0"
                                max="999999999999"
                                maxlength="20"
                                oninput="this.value=this.value.slice(0,this.maxLength||1/1);
                                this.value=(this.value   < 0) ? (1/1) : this.value;"
                                @keyup="
                                  validateNotNull(
                                    'bookMinWholesaleZone3Part' + (index + 1)
                                  )
                                "
                                class="form-control"
                                type="number"
                                :value="minGrosir[index]"
                                :name="
                                  'bookMinWholesaleZone3Part' + (index + 1)
                                "
                                :id="'bookMinWholesaleZone3Part' + (index + 1)"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md">
                        <div class="form-group">
                          <label class="text-success"
                            >Harga Grosir {{ index + 1 }}</label
                          >
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <label class="input-group-text">Rp.</label>
                            </div>
                            <CurrencyInput
                              v-if="renderComponent"
                              :value="hargaGrosir[index]"
                              class="form-control"
                              @input="
                                grosirAutoCorrectPrice(
                                  `bookWholesalePriceZone3Part${index + 1}`,
                                  'maxZone3'
                                )
                              "
                              :name="
                                'bookWholesalePriceZone3Part' + (index + 1)
                              "
                              :id="'bookWholesalePriceZone3Part' + (index + 1)"
                            />
                            <div
                              :class="
                                `invalid-feedback invalidbookWholesalePriceZone3Part${index +
                                  1}`
                              "
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade show"
                id="grosirZone4"
                role="tabpanel"
                aria-labelledby="grosirZone5-tab"
              >
                <div class="row">
                  <div class="col-12">
                    <div
                      class="form-row"
                      v-for="(fakeForEach, index) in 4"
                      :key="index"
                    >
                      <div class="col-md-2">
                        <div class="form-group">
                          <div class="form-group">
                            <label>Pembelian Minimum</label>
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <label class="input-group-text">Min.</label>
                              </div>
                              <input
                                min="0"
                                max="999999999999"
                                maxlength="20"
                                oninput="this.value=this.value.slice(0,this.maxLength||1/1);
                                this.value=(this.value   < 0) ? (1/1) : this.value;"
                                @keyup="
                                  validateNotNull(
                                    'bookMinWholesaleZone4Part' + (index + 1)
                                  )
                                "
                                class="form-control"
                                type="number"
                                :value="minGrosir[index]"
                                :name="
                                  'bookMinWholesaleZone4Part' + (index + 1)
                                "
                                :id="'bookMinWholesaleZone4Part' + (index + 1)"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md">
                        <div class="form-group">
                          <label class="text-success"
                            >Harga Grosir {{ index + 1 }}</label
                          >
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <label class="input-group-text">Rp.</label>
                            </div>
                            <CurrencyInput
                              v-if="renderComponent"
                              :value="hargaGrosir[index]"
                              @input="
                                grosirAutoCorrectPrice(
                                  `bookWholesalePriceZone4Part${index + 1}`,
                                  'maxZone4'
                                )
                              "
                              class="form-control"
                              :name="
                                'bookWholesalePriceZone4Part' + (index + 1)
                              "
                              :id="'bookWholesalePriceZone4Part' + (index + 1)"
                            />
                            <div
                              :class="
                                `invalid-feedback invalidbookWholesalePriceZone4Part${index +
                                  1}`
                              "
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade show"
                id="grosirZone5"
                role="tabpanel"
                aria-labelledby="grosirZone5-tab"
              >
                <div class="row">
                  <div class="col-12">
                    <div
                      class="form-row"
                      v-for="(fakeForEach, index) in 4"
                      :key="index"
                    >
                      <div class="col-md-2">
                        <div class="form-group">
                          <div class="form-group">
                            <label>Pembelian Minimum</label>
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <label class="input-group-text">Min.</label>
                              </div>
                              <input
                                min="0"
                                max="999999999999"
                                maxlength="20"
                                oninput="this.value=this.value.slice(0,this.maxLength||1/1);
                                this.value=(this.value   < 0) ? (1/1) : this.value;"
                                @keyup="
                                  validateNotNull(
                                    'bookMinWholesaleZone5Part' + (index + 1)
                                  )
                                "
                                class="form-control"
                                type="number"
                                :value="minGrosir[index]"
                                :name="
                                  'bookMinWholesaleZone5Part' + (index + 1)
                                "
                                :id="'bookMinWholesaleZone5Part' + (index + 1)"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md">
                        <div class="form-group">
                          <label class="text-success"
                            >Harga Grosir {{ index + 1 }}</label
                          >
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <label class="input-group-text">Rp.</label>
                            </div>
                            <CurrencyInput
                              v-if="renderComponent"
                              :value="hargaGrosir[index]"
                              class="form-control"
                              @input="
                                grosirAutoCorrectPrice(
                                  `bookWholesalePriceZone5Part${index + 1}`,
                                  'maxZone5'
                                )
                              "
                              :name="
                                'bookWholesalePriceZone5Part' + (index + 1)
                              "
                              :id="'bookWholesalePriceZone5Part' + (index + 1)"
                            />
                            <div
                              :class="
                                `invalid-feedback invalidbookWholesalePriceZone5Part${index +
                                  1}`
                              "
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="form-row">
              <div class="col-md-3">
                <div class="form-group">
                  <label>Stok</label>
                  <CurrencyInput
                    v-if="renderComponent"
                    v-model="stock"
                    name="bookStock"
                    class="form-control"
                    id="bookStock"
                    @keyup="validateNotNull('bookStock')"
                  />
                  <div class="invalid-feedback invalidStock"></div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <label>PPN 10%</label>
                  <select name="bookPpn" class="form-control" id="bookPpn">
                    <option value="0">Non PPN</option>
                    <option value="1">Include PPN</option>
                    <option value="2">Exclude PPN</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>Harga</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <label class="input-group-text">Rp.</label>
                    </div>
                    <CurrencyInput
                      v-if="renderComponent"
                      name="nonTextPrice"
                      :value="nonTextPrice"
                      class="form-control"
                      id="nonTextPrice"
                      disabled
                    />
                    <div class="invalid-feedback invalidbookPriceZone2"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card-header">
            <b>Harga Grosir</b>
            <button
              class="ml-2 mr-2 btn btn-secondary btn-circle btn-sm collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#grosirCollapse"
              aria-expanded="false"
              aria-controls="grosirCollapse"
            >
              <i
                class="fa fa-compress"
                style="font-size: 12px"
                aria-hidden="true"
              ></i>
            </button>
            <p class="grosir-info">
              Masukkan harga grosir. Harga grosir biasanya lebih murah daripada
              harga satuan. Harga grosir memiliki minimum pembelian dan harga
              bertingkat (3-4 tingkat). Barang seperti ini disebut juga barang
              Wholesale.
            </p>
          </div>
          <div class="card-body collapse" id="grosirCollapse" style="">
            <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="pills-home-tab"
                  data-toggle="pill"
                  href="#grosirZone1"
                  role="tab"
                  aria-controls="pills-home"
                  aria-selected="true"
                  ><span style="font-size: 12px">Grosir Zona 1</span>
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="pills-profile-tab"
                  data-toggle="pill"
                  href="#grosirZone2"
                  role="tab"
                  aria-controls="pills-profile"
                  aria-selected="false"
                  ><span style="font-size: 12px">Grosir Zona 2</span></a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="pills-profile-tab"
                  data-toggle="pill"
                  href="#grosirZone3"
                  role="tab"
                  aria-controls="pills-profile"
                  aria-selected="false"
                  ><span style="font-size: 12px">Grosir Zona 3</span></a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="pills-profile-tab"
                  data-toggle="pill"
                  href="#grosirZone4"
                  role="tab"
                  aria-controls="pills-profile"
                  aria-selected="false"
                  ><span style="font-size: 12px">Grosir Zona 4</span></a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="pills-profile-tab"
                  data-toggle="pill"
                  href="#grosirZone5"
                  role="tab"
                  aria-controls="pills-profile"
                  aria-selected="false"
                  ><span style="font-size: 12px">Grosir Zona 5</span></a
                >
              </li>
            </ul>
            <div class="tab-content" id="pills-tabContent">
              <div
                class="tab-pane fade show active"
                id="grosirZone1"
                role="tabpanel"
                aria-labelledby="grosirZone5-tab"
              >
                <div class="row">
                  <div class="col-12">
                    <div
                      class="form-row"
                      v-for="(fakeForEach, index) in 4"
                      :key="index"
                    >
                      <div class="col-md-2">
                        <div class="form-group">
                          <div class="form-group">
                            <label>Pembelian Minimum</label>
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <label class="input-group-text">Min.</label>
                              </div>
                              <input
                                min="0"
                                max="999999999999"
                                maxlength="20"
                                oninput="this.value=this.value.slice(0,this.maxLength||1/1);
                                this.value=(this.value   < 0) ? (1/1) : this.value;"
                                @keyup="
                                  validateNotNull(
                                    'bookMinWholesaleZone1Part' + (index + 1)
                                  )
                                "
                                class="form-control"
                                type="number"
                                :value="minGrosir[index]"
                                :name="
                                  'bookMinWholesaleZone1Part' + (index + 1)
                                "
                                :id="'bookMinWholesaleZone1Part' + (index + 1)"
                              />
                              <span class="invalid-feedback"
                                >Tidak boleh kosong</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md">
                        <div class="form-group">
                          <label class="text-success"
                            >Harga Grosir {{ index + 1 }}</label
                          >
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <label class="input-group-text">Rp.</label>
                            </div>
                            <CurrencyInput
                              v-if="renderComponent"
                              :value="hargaGrosir[index]"
                              class="form-control"
                              min="0"
                              max="999999999999"
                              maxlength="20"
                              oninput="this.value=this.value.slice(0,this.maxLength||1/1);
                              this.value=(this.value   < 0) ? (1/1) : this.value;"
                              @input="
                                grosirAutoCorrectPrice(
                                  `bookWholesalePriceZone1Part${index + 1}`,
                                  'maxZone1'
                                )
                              "
                              :name="
                                'bookWholesalePriceZone1Part' + (index + 1)
                              "
                              :id="'bookWholesalePriceZone1Part' + (index + 1)"
                            />
                            <div
                              :class="
                                `invalid-feedback invalidbookWholesalePriceZone1Part${index +
                                  1}`
                              "
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade show"
                id="grosirZone2"
                role="tabpanel"
                aria-labelledby="grosirZone5-tab"
              >
                <div class="row">
                  <div class="col-12">
                    <div
                      class="form-row"
                      v-for="(fakeForEach, index) in 4"
                      :key="index"
                    >
                      <div class="col-md-2">
                        <div class="form-group">
                          <div class="form-group">
                            <label>Pembelian Minimum</label>
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <label class="input-group-text">Min.</label>
                              </div>
                              <input
                                min="0"
                                max="999999999999"
                                maxlength="20"
                                oninput="this.value=this.value.slice(0,this.maxLength||1/1);
                                this.value=(this.value   < 0) ? (1/1) : this.value;"
                                @keyup="
                                  validateNotNull(
                                    'bookMinWholesaleZone2Part' + (index + 1)
                                  )
                                "
                                class="form-control"
                                type="number"
                                :value="minGrosir[index]"
                                :name="
                                  'bookMinWholesaleZone2Part' + (index + 1)
                                "
                                :id="'bookMinWholesaleZone2Part' + (index + 1)"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md">
                        <div class="form-group">
                          <label class="text-success"
                            >Harga Grosir {{ index + 1 }}</label
                          >
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <label class="input-group-text">Rp.</label>
                            </div>
                            <CurrencyInput
                              v-if="renderComponent"
                              :value="hargaGrosir[index]"
                              class="form-control"
                              @input="
                                grosirAutoCorrectPrice(
                                  `bookWholesalePriceZone2Part${index + 1}`,
                                  'maxZone2'
                                )
                              "
                              :name="
                                'bookWholesalePriceZone2Part' + (index + 1)
                              "
                              :id="'bookWholesalePriceZone2Part' + (index + 1)"
                            />
                            <div
                              :class="
                                `invalid-feedback invalidbookWholesalePriceZone2Part${index +
                                  1}`
                              "
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade show"
                id="grosirZone3"
                role="tabpanel"
                aria-labelledby="grosirZone5-tab"
              >
                <div class="row">
                  <div class="col-12">
                    <div
                      class="form-row"
                      v-for="(fakeForEach, index) in 4"
                      :key="index"
                    >
                      <div class="col-md-2">
                        <div class="form-group">
                          <div class="form-group">
                            <label>Pembelian Minimum</label>
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <label class="input-group-text">Min.</label>
                              </div>
                              <input
                                min="0"
                                max="999999999999"
                                maxlength="20"
                                oninput="this.value=this.value.slice(0,this.maxLength||1/1);
                                this.value=(this.value   < 0) ? (1/1) : this.value;"
                                @keyup="
                                  validateNotNull(
                                    'bookMinWholesaleZone3Part' + (index + 1)
                                  )
                                "
                                class="form-control"
                                type="number"
                                :value="minGrosir[index]"
                                :name="
                                  'bookMinWholesaleZone3Part' + (index + 1)
                                "
                                :id="'bookMinWholesaleZone3Part' + (index + 1)"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md">
                        <div class="form-group">
                          <label class="text-success"
                            >Harga Grosir {{ index + 1 }}</label
                          >
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <label class="input-group-text">Rp.</label>
                            </div>
                            <CurrencyInput
                              v-if="renderComponent"
                              :value="hargaGrosir[index]"
                              class="form-control"
                              @input="
                                grosirAutoCorrectPrice(
                                  `bookWholesalePriceZone3Part${index + 1}`,
                                  'maxZone3'
                                )
                              "
                              :name="
                                'bookWholesalePriceZone3Part' + (index + 1)
                              "
                              :id="'bookWholesalePriceZone3Part' + (index + 1)"
                            />
                            <div
                              :class="
                                `invalid-feedback invalidbookWholesalePriceZone3Part${index +
                                  1}`
                              "
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade show"
                id="grosirZone4"
                role="tabpanel"
                aria-labelledby="grosirZone5-tab"
              >
                <div class="row">
                  <div class="col-12">
                    <div
                      class="form-row"
                      v-for="(fakeForEach, index) in 4"
                      :key="index"
                    >
                      <div class="col-md-2">
                        <div class="form-group">
                          <div class="form-group">
                            <label>Pembelian Minimum</label>
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <label class="input-group-text">Min.</label>
                              </div>
                              <input
                                min="0"
                                max="999999999999"
                                maxlength="20"
                                oninput="this.value=this.value.slice(0,this.maxLength||1/1);
                                this.value=(this.value   < 0) ? (1/1) : this.value;"
                                @keyup="
                                  validateNotNull(
                                    'bookMinWholesaleZone4Part' + (index + 1)
                                  )
                                "
                                class="form-control"
                                type="number"
                                :value="minGrosir[index]"
                                :name="
                                  'bookMinWholesaleZone4Part' + (index + 1)
                                "
                                :id="'bookMinWholesaleZone4Part' + (index + 1)"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md">
                        <div class="form-group">
                          <label class="text-success"
                            >Harga Grosir {{ index + 1 }}</label
                          >
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <label class="input-group-text">Rp.</label>
                            </div>
                            <CurrencyInput
                              v-if="renderComponent"
                              :value="hargaGrosir[index]"
                              @input="
                                grosirAutoCorrectPrice(
                                  `bookWholesalePriceZone4Part${index + 1}`,
                                  'maxZone4'
                                )
                              "
                              class="form-control"
                              :name="
                                'bookWholesalePriceZone4Part' + (index + 1)
                              "
                              :id="'bookWholesalePriceZone4Part' + (index + 1)"
                            />
                            <div
                              :class="
                                `invalid-feedback invalidbookWholesalePriceZone4Part${index +
                                  1}`
                              "
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade show"
                id="grosirZone5"
                role="tabpanel"
                aria-labelledby="grosirZone5-tab"
              >
                <div class="row">
                  <div class="col-12">
                    <div
                      class="form-row"
                      v-for="(fakeForEach, index) in 4"
                      :key="index"
                    >
                      <div class="col-md-2">
                        <div class="form-group">
                          <div class="form-group">
                            <label>Pembelian Minimum</label>
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <label class="input-group-text">Min.</label>
                              </div>
                              <input
                                min="0"
                                max="999999999999"
                                maxlength="20"
                                oninput="this.value=this.value.slice(0,this.maxLength||1/1);
                                this.value=(this.value   < 0) ? (1/1) : this.value;"
                                @keyup="
                                  validateNotNull(
                                    'bookMinWholesaleZone5Part' + (index + 1)
                                  )
                                "
                                class="form-control"
                                type="number"
                                :value="minGrosir[index]"
                                :name="
                                  'bookMinWholesaleZone5Part' + (index + 1)
                                "
                                :id="'bookMinWholesaleZone5Part' + (index + 1)"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md">
                        <div class="form-group">
                          <label class="text-success"
                            >Harga Grosir {{ index + 1 }}</label
                          >
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <label class="input-group-text">Rp.</label>
                            </div>
                            <CurrencyInput
                              v-if="renderComponent"
                              :value="hargaGrosir[index]"
                              class="form-control"
                              @input="
                                grosirAutoCorrectPrice(
                                  `bookWholesalePriceZone5Part${index + 1}`,
                                  'maxZone5'
                                )
                              "
                              :name="
                                'bookWholesalePriceZone5Part' + (index + 1)
                              "
                              :id="'bookWholesalePriceZone5Part' + (index + 1)"
                            />
                            <div
                              :class="
                                `invalid-feedback invalidbookWholesalePriceZone5Part${index +
                                  1}`
                              "
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
// import axios from "axios";
import $ from "jquery";
// import { parse } from "vue-currency-input";

export default {
  props: {
    zone1: Number,
    zone2: Number,
    zone3: Number,
    zone4: Number,
    zone5: Number,
    typeBook: String,
    nonTextPrice: Number,
    renderComponent: Boolean,
    hargaNormal: Number,
    inputdationGrosirText: String,
    grosirAutoCorrectPrice: Function,
  },
  data() {
    return {
      maksNego: 0,
      stock: 0,
      minGrosir: [0, 0, 0, 0],
      hargaGrosir: [0, 0, 0, 0],
      isChecked: false,
      ppnValue: 0,
    };
  },
  watch: {
    hargaNormal() {
      if (this.hargaNormal === null) {
        $(".invalidHargaNormal").text(`Harga tidak boleh kosong`);
        $("#harga_normal").addClass("is-invalid");
      } else {
        $("#harga_normal").removeClass("is-invalid");
      }
    },
    maksNego() {
      if (this.maksNego === null) {
        $(".invalidMaksNego").text(`Harga tidak boleh kosong`);
        $("#maks_nego").addClass("is-invalid");
      } else {
        $("#maks_nego").removeClass("is-invalid");
      }
    },
    stock() {
      if (this.stock === null) {
        $(".invalidStock").text(`Stok tidak boleh kosong`);
        $("#stock").addClass("is-invalid");
      } else {
        $("#stock").removeClass("is-invalid");
      }
    },
  },
  created() {},
  async mounted() {
    await this.$nextTick();
    // $(".toggle_table").bootstrapToggle();
    this.togglerPajak();
  },
  methods: {
    validateNotNull(idEl) {
      let element = $(`#${idEl}`);

      if (element.val().includes("-")) {
        $(`#${idEl}`).val(0);
      }

      if (element.val() === "") {
        element.addClass("is-invalid");
      } else {
        element.removeClass("is-invalid");
      }
    },
    togglerPajak() {
      let gThis = this;
      /* eslint-disable no-unused-vars */
      setInterval(() => {
        $(".toggle_table").bootstrapToggle();
      }, 200);
      $(".toggle_table").on("change", function() {
        gThis.changePajak();
      });
    },
    async changePajak() {
      if (this.isChecked === false) {
        this.ppnValue = 1;
        this.isChecked = true;
        return this.$swal.fire(
          `<span style='font-size:17px'>PPN 10% Diaktifkan</span>`,
          "Pajak akan ditanggung oleh toko!",
          "info"
        );
      } else {
        this.ppnValue = 0;
        this.isChecked = false;
        // return this.$toast.error('PPN 10% Tidak Diaktifkan',{icon: true,})
        return this.$swal.fire(
          `<span style='font-size:17px'>PPN 10% Tidak Diaktifkan</span>`,
          "Pajak akan ditanggung oleh sekolah!",
          "info"
        );
      }
    },
    handleErrorHarga() {},
    autoCorrectPrice(numberZone, maxNumberZone) {
      let zoneDef = $(`#${numberZone}`).val();
      let maxZone = $(`#${maxNumberZone}`).val();
      let splitedZone = Number(zoneDef.split(".").join(""));
      let splitedMaxZone = Number(maxZone.split(".").join(""));

      if (splitedZone > splitedMaxZone) {
        $(`.invalid${numberZone}`).text(
          `Harga tidak boleh melewati harga maksimal ${numberZone} (Rp${maxZone})`
        );
        $(`#${numberZone}`).addClass("is-invalid");
        // $(`#${numberZone}`).val(splitedMaxZone)
        // this.$swal.fire({
        //   title:`<span style='font-size:17px'>Harga tidak boleh melewati harga maksimal ${numberZone} (Rp${maxZone})</span>`,
        //   icon:'warning'
        // }).then(() => {
        //   $(`#${numberZone}`).val(maxZone)
        // })
      } else if (zoneDef.includes("-")) {
        $(`#${numberZone}`).val(0);
      } else {
        $(`#${numberZone}`).removeClass("is-invalid");
      }

      if (splitedZone.toString() < 1) {
        $(`.invalid${numberZone}`).text(`Harga tidak boleh kosong`);
        $(`#${numberZone}`).addClass("is-invalid");
        // $(`#${numberZone}`).val()
        // this.$swal.fire({
        //   title:`<span style='font-size:17px'>Harga tidak boleh kosong</span>`,
        //   icon:'warning'
        // })
      }
    },
  },
};
</script>
